// services/sponsorService.js

import api from './axiosConfig';

const sponsorService = {
  create(championshipId, formData) {
    // IMPORTANTE: adiciona o championshipId no corpo
    formData.append('championship', championshipId);

    return api.post(`/sponsors`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  listByChampionship(championshipId) {
    return api.get(`/sponsors/championship/${championshipId}`);
  },

  delete(id) {
    return api.delete(`/sponsors/${id}`);
  }
};

export default sponsorService;
